<template>
  <div class="color-picker">
    <div class="color-options">
      <div
        v-for="color in colors"
        :key="color"
        class="color-option"
        :style="{backgroundColor: color}"
        @click="$emit('input', color)"
        :class="{'selected': value === color}"
      ></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ColorPicker',
    props: {
      value: String,
      colors: Array
    }
  }
</script>

<style>
  .color-picker {
    display: inline-block;
    margin-left: 10px;
  }

  .color-options {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    width: 200px;
  }

  .color-option {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.3s;
  }

  .color-option:hover {
    transform: scale(1.1);
  }

  .color-option.selected {
    border-color: #333;
    transform: scale(1.1);
  }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/SignPDF/SignColorPicker.vue